__turbopack_context__.v({
  "checkbox": "XLEq2W_checkbox",
  "checkboxGroup": "XLEq2W_checkboxGroup",
  "options": "XLEq2W_options",
});
